import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CssUtilitiesService {

  constructor() { }

  textareaHeight(id: string, minHeight: number): string {
    // I was using AutosizeModule (https://github.com/chrum/ngx-autosize) but it was giving the
    // elements way too much height. Clearly a bug. Decided to roll my own.
    // https://stackoverflow.com/questions/50762433/resizetextarea-in-angular-5
    const textArea = document.getElementById(id)
    if (!textArea) {
      return minHeight + 'px'
    }
    textArea.style.overflow = 'hidden'
    // textArea.style.height = 'auto'   // this is part of the documented solution, but causes the Notes field to jump (Safari)
    textArea.style.height = Math.max(minHeight, textArea.scrollHeight) + 'px'
    return textArea.style.height
  }
}
